<template>
  <el-dialog :close-on-click-modal="false" title="产品" :visible.sync="isShow" width="1000px">
    <el-form :inline="true" :model="spuVO" label-width="80px" class="demo-form-inline">
      <el-row>
        <!-- <el-row> -->
        <el-col :span="8">
          <el-form-item label="产品名称:">
            <el-input v-model="spuVO.spuName" placeholder="请输入产品名称" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="产品性质:">
            <el-select v-model="spuVO.spuProperty" placeholder="请选择" clearable>
              <el-option label="" value="">全部</el-option>
              <el-option v-for="item in natureList" :key="item.id" :label="item.dictValue" :value="item.dictCode"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="产品分类:">
            <el-cascader v-if="isShow" :show-all-levels="false" placeholder="请选择" clearable v-model="spuVO.categoryId" :props="props"></el-cascader>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="产品属性:">
            <el-select v-model="spuVO.isSeries" placeholder="请选择" clearable>
              <el-option label="" value="">全部</el-option>
              <el-option label="普通产品" value="0"></el-option>
              <el-option label="套系产品" value="1"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8" class="fn-right form-btn" style="margin-top:0;">
          <el-button class="search-ok" @click="queryInfo.pageNum = 1, onSubmit()" round>查询</el-button>
          <el-button type="primary" @click="$refs.addPro.show(tagsId, storeTypeName)" round>添加产品</el-button>
        </el-col>
      </el-row>
    </el-form>
    <el-table :data="spuList" style="width: 100%">
      <el-table-column prop="spuName" label="产品名称"></el-table-column>
      <el-table-column prop="spuImage" label="产品图片">
        <template slot-scope="scope">
          <el-image style="width: 100px; height: 100px" :src="scope.row.spuImage + '?x-sds-process=image/resize,l_98,m_mfit'" fit="cover"></el-image>
        </template>
      </el-table-column>
      <el-table-column prop="categoryName" label="产品分类"></el-table-column>
      <el-table-column prop="spuProperty" label="产品性质">
        <template slot-scope="scope"> {{ $config.spuType[scope.row.spuProperty] }} </template>
      </el-table-column>
      <el-table-column prop="isSeries" label="产品属性">
        <template slot-scope="scope"> {{ scope.row.isSeries ? "套系" : "单品" }} </template>
      </el-table-column>
      <el-table-column label="操作" width="110px">
        <template slot-scope="scope">
          <span class="color-blue" v-permission="'pos:admin:spu:update'" @click="editProduct(scope.row)">编辑</span><br />
          <span class="color-blue" v-permission="'pos:admin:tags:removeSpu'" @click="deleteId = scope.row.spuId, deleteDialog = true"> 删除 </span>
        </template>
      </el-table-column>
      <!--      <el-table-column prop="spuName" label="操作">-->
      <!--        <template>-->
      <!--          <span class="color-blue">编 辑<br></span>-->
      <!--          <span class="color-blue">删 除</span>-->
      <!--        </template>-->
      <!--      </el-table-column>-->
    </el-table>
    <addPro @fatherMethod="onSubmit" ref="addPro"></addPro>
    <EditProductDialog @fatherMethod="onSubmit" ref="EditProductDialog" />
    <span slot="footer" class="dialog-footer">
      <el-button @click="isShow = false">取 消</el-button>
      <el-button type="primary" @click="isShow = false">确 定</el-button>
    </span>
    <!-- 删除确认 -->
    <el-dialog :close-on-click-modal="false" append-to-body title="确认" :visible.sync="deleteDialog" width="30%">
      <span>确认删除该线上产品？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteDialog = false">取 消</el-button>
        <el-button type="primary" @click="del(deleteId)">确 定</el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>

<script>
import addPro from './addProDialog/index.vue'
import EditProductDialog from './editProDialog/index.vue'
import { posCategoryList, posCategoryQueryAllSubs, posSpuList, spuList, categoryGet, categoryList, queryAllSubs, spuProperty, categoryQuerySub, spuDelete, deleteSpu } from '@/api/pms'

export default {
  components: {
    addPro,
    EditProductDialog
  },
  data () {
    let _this = this
    return {
      deleteDialog: false,
      isShow: false,
      spuList: [],
      storeTypeName: '',
      spuVO: {
        isSeries: '',
        categoryId: '',
        onSale: '',
        spuName: '',
        spuProperty: '',
        tagsId: '',
        flag: '0'
      },
      natureList: [],
      resolve: {},
      queryInfo: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      tagsId: '',
      props: {
        checkStrictly: true,
        emitPath: false,
        lazy: true,
        lazyLoad (node, resolve) {
          console.log(node)
          const { level, value } = node
          if (level === 0) {
            posCategoryList(_this.tagsId).then(res => {
              let nodes = res.data.data.map(item => {
                return {
                  value: item.categoryId,
                  label: item.categoryName,
                  leaf: item.bottom
                }
              })
              resolve(nodes)
            })
          } else if (level === 1) {
            posCategoryQueryAllSubs(value).then(res => {
              let nodes = res.data.data.subCategoryList.map(item => {
                return {
                  value: item.categoryId,
                  label: item.categoryName,
                  leaf: true
                }
              })
              resolve(nodes)
            })
          } else {
            resolve([])
          }
        }
      }
    }
  },
  created () {
    this.getProNature()
  },
  methods: {
    del (id) {
      deleteSpu(id)
        .then(res => {
          if (res.data.success) {
            this.$message.success('删除成功')
            this.onSubmit()
            this.deleteDialog = false
          }
        })
    },
    editProduct (val) {
      this.$refs.EditProductDialog.show(val)
    },
    show (tagsId, storeTypeName) {
      this.tagsId = tagsId
      this.storeTypeName = storeTypeName
      this.spuVO.tagsId = tagsId
      this.onSubmit()
      this.isShow = true
    },
    onSubmit () {
      posSpuList({
        pageNum: this.queryInfo.pageNum,
        pageSize: this.queryInfo.pageSize,
        spuVO: this.spuVO
      })
        .then(res => {
          if (res.data.success) {
            this.spuList = res.data.data.records
            this.queryInfo.total = res.data.data.total
          }
        })
    },
    // 获取产品性质
    getProNature () {
      spuProperty().then((res) => {
        this.natureList = res.data.data
      })
    }
  }
}
</script>

<style>
</style>
